import isUserSignedInLoader from "@loaders/isUserSignedInLoader"
import PreparingPage from "@pages/signUp/PreparingPage"
import SignUpPage from "@pages/signUp/SignUpPage"
import { Navigate } from "react-router-dom"

// NOTE: One step for email and password (it used to be two, password first,
// keeping the password in sessionStorage in between). `password` stays as a
// redirect for old links and history entries.
const signUpRoutes = [
  {
    index: true,
    element: <Navigate to="email" replace />,
  },
  {
    element: <SignUpPage />,
    loader: isUserSignedInLoader,
    path: "email",
  },
  {
    element: <PreparingPage />,
    path: "preparing",
  },
  {
    element: <Navigate to="/sign-up/email" replace />,
    path: "password",
  },
]

export default signUpRoutes
